export default __webpack_public_path__ + "static/green-school_5-b95dbe2297e5758c4ee2462152eb7aba.png";